
import { mixins, Options } from 'vue-class-component'
import BaseFormDialogMixin from '@/components/common/mixins/BaseFormDialogMixin.vue'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageBubble, IFlexMessageCarousel } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue', 'submitJson'],
})
export default class FlexMessageJSONModal extends mixins(BaseFormDialogMixin) {
  @Prop()
  modelValue!: IFlexMessageBubble | IFlexMessageCarousel

  @Prop()
  isAdmin!: boolean

  jsonString = ''

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBubble | IFlexMessageCarousel) {
    this.$emit('update:modelValue', value)
  }

  onSubmit() {
    this.value = JSON.parse(this.jsonString)
    this.$emit('submitJson', JSON.parse(this.jsonString))
    this.visible = false
  }

  @Watch('modelValue', { deep: true })
  syncJsonString() {
    this.jsonString = JSON.stringify(this.modelValue, null, 2)
  }

  created() {
    this.syncJsonString()
  }
}
